export class OtherScreenFiltersDataModel {
  selectedPickupLocation: String = '';
  selectedDropLocation: String = '';
  fromDateMilliSeconds: Number = 0;
  toDateMilliSeconds: Number = 0;
  selectedPassengerType: String = '';
  selectedDispatchAddress: String = '';
  selectedBookingStatus: any = '';
  selectedJourneyType: String = '';
  selectedSortType: String = '';
  opencloseFilter: boolean = false;
  selectedVehicleTypeId: String = '';
  nextAvailableTime?: any;

  constructor(options?: {
    selectedPickupLocation: String;
    selectedDropLocation: String;
    fromDateMilliSeconds: Number;
    toDateMilliSeconds: any;
    selectedPassengerType: String;
    selectedDispatchAddress: String;
    selectedBookingStatus: any;
    selectedJourneyType: String;
    selectedSortType: String;
    opencloseFilter: boolean;
    selectedVehicleTypeId: String;
    nextAvailableTime?: any;
  }) {
    if (options) {
      this.selectedPickupLocation = options.selectedPickupLocation;
      this.selectedDropLocation = options.selectedDropLocation;
      this.fromDateMilliSeconds = options.fromDateMilliSeconds;
      this.toDateMilliSeconds = options.toDateMilliSeconds;
      this.selectedPassengerType = options.selectedPassengerType;
      this.selectedDispatchAddress = options.selectedDispatchAddress;
      this.selectedBookingStatus = options.selectedBookingStatus;
      this.selectedJourneyType = options.selectedJourneyType;
      this.selectedSortType = options.selectedSortType;
      this.opencloseFilter = options.opencloseFilter;
      this.selectedVehicleTypeId = options.selectedVehicleTypeId
      this.nextAvailableTime = options.nextAvailableTime
    }
  }

}
